import ExamCreatePage from "./ExamCreatePage";

export default ExamCreatePage;